export const DEFAULT_CUSTOMS_OFFICES = [
    // ========= TURKEY (first) =========
    "İstanbul Havalimanı Gümrük",
    "Sabiha Gökçen Havalimanı Gümrük",
    "Ambarlı Limanı Gümrük (İstanbul)",
    "Haydarpaşa Limanı Gümrük (İstanbul)",
    "Pendik Limanı Gümrük (İstanbul)",
    "Erenköy Gümrük (İstanbul)",
    "Halkalı Gümrük (İstanbul)",
    "İzmir Alsancak Limanı Gümrük",
    "Aliağa/Çandarlı Bölgesi Gümrük (İzmir)",
    "Mersin Limanı Gümrük",
    "İskenderun Limanı Gümrük (Hatay)",
    "Gemlik Limanı Gümrük (Bursa)",
    "Mudanya Bölgesi Gümrük (Bursa)",
    "Derince Limanı Gümrük (Kocaeli)",
    "Dilovası Bölgesi Gümrük (Kocaeli)",
    "Gebze Gümrük (Kocaeli)",
    "Yalova Ro-Ro Gümrük",
    "Tekirdağ Limanı Gümrük",
    "Samsun Limanı Gümrük",
    "Trabzon Limanı Gümrük",
    "Antalya Limanı Gümrük",
    "Bodrum Limanı Gümrük (Muğla)",
    "Marmaris Limanı Gümrük (Muğla)",
    "Dalaman Havalimanı Gümrük (Muğla)",
    "Eskişehir Gümrük",
    "Ankara (Esenboğa) Havalimanı Gümrük",
    "Ankara Gümrük (İç Gümrük)",
    "Bursa Gümrük",
    "Konya Gümrük",
    "Kayseri Gümrük",
    "Gaziantep Gümrük",
    "Şanlıurfa Gümrük",
    "Adana Gümrük",
    "Kahramanmaraş Gümrük",
    "Malatya Gümrük",
    "Erzurum Gümrük",
    "Kars Gümrük",
    "Sarp Sınır Kapısı Gümrük (Artvin)",
    "Kapıkule Sınır Kapısı Gümrük (Edirne)",
    "İpsala Sınır Kapısı Gümrük (Edirne)",
    "Hamzabeyli Sınır Kapısı Gümrük (Edirne)",
    "Kapıköy Sınır Kapısı Gümrük (Van)",
    "Gürbulak Sınır Kapısı Gümrük (Ağrı)",
    "Habur Sınır Kapısı Gümrük (Şırnak)",
    "Cilvegözü Sınır Kapısı Gümrük (Hatay)",
    "Öncüpınar Sınır Kapısı Gümrük (Kilis)",
    "Dereköy Sınır Kapısı Gümrük (Kırklareli)",
    "Zonguldak Limanı Gümrük",
    "Bandırma Limanı Gümrük (Balıkesir)",

    // --- TURKEY: extra ports ---
    "Alanya Limanı Gümrük (Antalya)",
    "Fethiye Limanı Gümrük (Muğla)",
    "Güllük Limanı Gümrük (Muğla)",
    "Çeşme Limanı Gümrük (İzmir)",
    "Dikili Limanı Gümrük (İzmir)",
    "Kuşadası Limanı Gümrük (Aydın)",
    "Çanakkale Limanı Gümrük",
    "Gelibolu Limanı Gümrük (Çanakkale)",
    "İzmit Körfezi Limanları Gümrük (Kocaeli)",
    "Karasu Limanı Gümrük (Sakarya)",
    "Ereğli Limanı Gümrük (Zonguldak)",
    "Rize Limanı Gümrük",
    "Hopa Limanı Gümrük (Artvin)",
    "Ordu-Giresun Havalimanı Gümrük",
    "Diyarbakır Havalimanı Gümrük",
    "Adana Şakirpaşa / Çukurova Bölgesi Gümrük",
    "Çukurova Bölgesel Havalimanı Gümrük (Adana/Mersin)",

    // --- TURKEY: extra inland / logistics hubs ---
    "Manisa Gümrük",
    "Denizli Gümrük",
    "Aydın Gümrük",
    "Sakarya Gümrük",
    "Kütahya Gümrük",
    "Afyonkarahisar Gümrük",
    "Isparta Gümrük",
    "Burdur Gümrük",
    "Sivas Gümrük",
    "Elazığ Gümrük",
    "Van Gümrük",
    "Mardin Gümrük",
    "Batman Gümrük",
    "Kocaeli Serbest Bölge Gümrük",
    "İstanbul Serbest Bölge Gümrük",
    "İzmir Serbest Bölge Gümrük",
    "Mersin Serbest Bölge Gümrük",

    // --- TURKEY: extra border gates (more coverage) ---
    "Çıldır/Aktaş Sınır Kapısı Gümrük (Ardahan)",
    "Türkgözü Sınır Kapısı Gümrük (Ardahan)",
    "Diloğu Sınır Kapısı Gümrük (Kars)",
    "Posof/Damal Bölgesi Gümrük (Ardahan)",
    "Esendere Sınır Kapısı Gümrük (Hakkari)",
    "Derecik Sınır Kapısı Gümrük (Hakkari)",
    "Nusaybin Sınır Kapısı Gümrük (Mardin)",
    "Karkamış Sınır Kapısı Gümrük (Gaziantep)",
    "Akçakale Sınır Kapısı Gümrük (Şanlıurfa)",
    "Yayladağı Sınır Kapısı Gümrük (Hatay)",
    "Akyaka Sınır Kapısı Gümrük (Kars)",
    "Sınır Kapıları (Trakya) Bölgesi Gümrük (Edirne/Kırklareli)",

    // ========= EUROPE =========
    "Port of Rotterdam Customs (Netherlands)",
    "Port of Antwerp-Bruges Customs (Belgium)",
    "Port of Hamburg Customs (Germany)",
    "Port of Bremerhaven Customs (Germany)",
    "Frankfurt Airport Customs (Germany)",
    "Amsterdam Schiphol Airport Customs (Netherlands)",
    "Paris Charles de Gaulle Airport Customs (France)",
    "Port of Le Havre Customs (France)",
    "Port of Marseille-Fos Customs (France)",
    "Port of Barcelona Customs (Spain)",
    "Port of Valencia Customs (Spain)",
    "Madrid Barajas Airport Customs (Spain)",
    "Port of Algeciras Customs (Spain)",
    "Port of Genoa Customs (Italy)",
    "Port of La Spezia Customs (Italy)",
    "Port of Trieste Customs (Italy)",
    "Milan Malpensa Airport Customs (Italy)",
    "Rome Fiumicino Airport Customs (Italy)",
    "Port of Piraeus Customs (Greece)",
    "Athens Airport Customs (Greece)",
    "Port of Thessaloniki Customs (Greece)",
    "Port of Constanta Customs (Romania)",
    "Port of Gdansk Customs (Poland)",
    "Port of Gdynia Customs (Poland)",
    "Warsaw Chopin Airport Customs (Poland)",
    "Port of Felixstowe Customs (United Kingdom)",
    "Port of Southampton Customs (United Kingdom)",
    "Port of London Gateway Customs (United Kingdom)",
    "London Heathrow Airport Customs (United Kingdom)",
    "Manchester Airport Customs (United Kingdom)",
    "Port of Dublin Customs (Ireland)",
    "Stockholm Arlanda Airport Customs (Sweden)",
    "Port of Gothenburg Customs (Sweden)",
    "Copenhagen Airport Customs (Denmark)",
    "Port of Aarhus Customs (Denmark)",
    "Oslo Airport Customs (Norway)",
    "Port of Oslo Customs (Norway)",
    "Helsinki Port Customs (Finland)",
    "Helsinki Airport Customs (Finland)",
    "Vienna Airport Customs (Austria)",
    "Port of Koper Customs (Slovenia)",
    "Port of Rijeka Customs (Croatia)",
    "Port of Lisbon Customs (Portugal)",
    "Port of Sines Customs (Portugal)",

    // --- EUROPE: extra Netherlands / Belgium / Germany ---
    "Port of Amsterdam Customs (Netherlands)",
    "Port of Vlissingen Customs (Netherlands)",
    "Port of Zeebrugge Customs (Belgium)",
    "Port of Ghent Customs (Belgium)",
    "Munich Airport Customs (Germany)",
    "Berlin Brandenburg Airport Customs (Germany)",
    "Port of Wilhelmshaven Customs (Germany)",

    // --- EUROPE: extra France / Spain / Italy ---
    "Port of Dunkirk Customs (France)",
    "Lyon Airport Customs (France)",
    "Port of Bilbao Customs (Spain)",
    "Port of Vigo Customs (Spain)",
    "Port of Tarragona Customs (Spain)",
    "Barcelona Airport Customs (Spain)",
    "Port of Naples Customs (Italy)",
    "Port of Livorno Customs (Italy)",
    "Venice Port Customs (Italy)",

    // --- EUROPE: extra UK / Ireland ---
    "Port of Tilbury Customs (United Kingdom)",
    "Port of Liverpool Customs (United Kingdom)",
    "Birmingham Airport Customs (United Kingdom)",
    "East Midlands Airport Customs (United Kingdom)",
    "Port of Cork Customs (Ireland)",
    "Shannon Airport Customs (Ireland)",

    // --- EUROPE: Nordics / Baltics / Central & East Europe ---
    "Port of Malmö Customs (Sweden)",
    "Gothenburg Landvetter Airport Customs (Sweden)",
    "Port of Hanko Customs (Finland)",
    "Port of Turku Customs (Finland)",
    "Port of Tallinn Customs (Estonia)",
    "Tallinn Airport Customs (Estonia)",
    "Port of Riga Customs (Latvia)",
    "Riga Airport Customs (Latvia)",
    "Port of Klaipeda Customs (Lithuania)",
    "Vilnius Airport Customs (Lithuania)",
    "Port of Bergen Customs (Norway)",
    "Bergen Airport Customs (Norway)",
    "Port of Reykjavik Customs (Iceland)",
    "Keflavik Airport Customs (Iceland)",
    "Port of Gdynia/Gdansk Region Customs (Poland)",
    "Katowice Airport Customs (Poland)",
    "Port of Szczecin Customs (Poland)",
    "Prague Airport Customs (Czechia)",
    "Brno Customs (Czechia)",
    "Budapest Airport Customs (Hungary)",
    "Port of Koper/Ljubljana Inland Customs (Slovenia)",
    "Zagreb Airport Customs (Croatia)",
    "Belgrade Airport Customs (Serbia)",
    "Sofia Airport Customs (Bulgaria)",
    "Port of Varna Customs (Bulgaria)",
    "Bucharest Airport Customs (Romania)",
    "Cluj Airport Customs (Romania)",
    "Zurich Airport Customs (Switzerland)",
    "Geneva Airport Customs (Switzerland)",
    "Basel Customs (Switzerland)",
    "Port of Genoa/Ligurian Region Customs (Italy)",

    // ========= WORLD =========
    "Port of Singapore Customs (Singapore)",
    "Changi Airport Customs (Singapore)",
    "Port of Shanghai Customs (China)",
    "Port of Ningbo-Zhoushan Customs (China)",
    "Port of Shenzhen/Yantian Customs (China)",
    "Port of Guangzhou/Nansha Customs (China)",
    "Port of Hong Kong Customs (Hong Kong)",
    "Port of Busan Customs (South Korea)",
    "Incheon Airport Customs (South Korea)",
    "Port of Tokyo Customs (Japan)",
    "Port of Yokohama Customs (Japan)",
    "Narita Airport Customs (Japan)",
    "Kansai Airport Customs (Japan)",
    "Port of Jebel Ali (Dubai) Customs (UAE)",
    "Abu Dhabi Port Customs (UAE)",
    "Doha Hamad Port Customs (Qatar)",
    "Hamad International Airport Customs (Qatar)",
    "Port of Dammam Customs (Saudi Arabia)",
    "King Abdulaziz Port Customs (Saudi Arabia)",
    "Port of Mumbai (Nhava Sheva/JNPT) Customs (India)",
    "Port of Chennai Customs (India)",
    "Delhi IGI Airport Customs (India)",
    "Port of Colombo Customs (Sri Lanka)",
    "Port of Tanjung Pelepas Customs (Malaysia)",
    "Port Klang Customs (Malaysia)",
    "Port of Laem Chabang Customs (Thailand)",
    "Bangkok Suvarnabhumi Airport Customs (Thailand)",
    "Port of Hai Phong Customs (Vietnam)",
    "Port of Ho Chi Minh (Cat Lai) Customs (Vietnam)",
    "Port of Jakarta (Tanjung Priok) Customs (Indonesia)",
    "Port of Sydney Customs (Australia)",
    "Port of Melbourne Customs (Australia)",
    "Auckland Port Customs (New Zealand)",
    "Port of Durban Customs (South Africa)",
    "Port of Cape Town Customs (South Africa)",
    "Port of Mombasa Customs (Kenya)",
    "Port of Lagos (Apapa) Customs (Nigeria)",
    "Port of Tangier Med Customs (Morocco)",
    "Port of Alexandria Customs (Egypt)",
    "Port Said Customs (Egypt)",
    "Port of Haifa Customs (Israel)",
    "Ben Gurion Airport Customs (Israel)",
    "Port of Santos Customs (Brazil)",
    "Port of Buenos Aires Customs (Argentina)",
    "Port of Callao Customs (Peru)",
    "Port of Manzanillo Customs (Mexico)",
    "Port of Lázaro Cárdenas Customs (Mexico)",
    "Port of Los Angeles Customs (USA)",
    "Port of Long Beach Customs (USA)",
    "Port of New York/New Jersey Customs (USA)",
    "Port of Savannah Customs (USA)",
    "Port of Houston Customs (USA)",
    "Chicago O'Hare Airport Customs (USA)",
    "Miami Airport Customs (USA)",
    "Port of Vancouver Customs (Canada)",
    "Port of Montreal Customs (Canada)",
    "Toronto Pearson Airport Customs (Canada)",

    // --- WORLD: China / East Asia extra ---
    "Port of Qingdao Customs (China)",
    "Port of Tianjin Customs (China)",
    "Port of Xiamen Customs (China)",
    "Port of Dalian Customs (China)",
    "Shanghai Pudong Airport Customs (China)",
    "Beijing Capital Airport Customs (China)",
    "Beijing Daxing Airport Customs (China)",
    "Port of Kaohsiung Customs (Taiwan)",
    "Taoyuan Airport Customs (Taiwan)",
    "Port of Keelung Customs (Taiwan)",
    "Port of Manila Customs (Philippines)",
    "Port of Cebu Customs (Philippines)",
    "Ninoy Aquino Airport Customs (Philippines)",
    "Port of Colombo/BOI Zone Customs (Sri Lanka)",

    // --- WORLD: Middle East extra ---
    "Sharjah Port Customs (UAE)",
    "Khalifa Port Customs (UAE)",
    "Dubai Airport (DXB) Customs (UAE)",
    "Abu Dhabi Airport (AUH) Customs (UAE)",
    "Port of Salalah Customs (Oman)",
    "Muscat Airport Customs (Oman)",
    "Port of Kuwait Customs (Kuwait)",
    "Kuwait Airport Customs (Kuwait)",
    "Bahrain Port Customs (Bahrain)",
    "Bahrain Airport Customs (Bahrain)",
    "Port of Umm Qasr Customs (Iraq)",
    "Baghdad Airport Customs (Iraq)",
    "Port of Aqaba Customs (Jordan)",
    "Amman Queen Alia Airport Customs (Jordan)",
    "Port of Beirut Customs (Lebanon)",
    "Beirut Airport Customs (Lebanon)",

    // --- WORLD: India / South Asia extra ---
    "Port of Mundra Customs (India)",
    "Port of Kolkata (Haldia) Customs (India)",
    "Port of Visakhapatnam Customs (India)",
    "Bengaluru Airport Customs (India)",
    "Mumbai Airport Customs (India)",
    "Chittagong Port Customs (Bangladesh)",
    "Dhaka Airport Customs (Bangladesh)",
    "Karachi Port Customs (Pakistan)",
    "Port Qasim Customs (Pakistan)",
    "Lahore Airport Customs (Pakistan)",

    // --- WORLD: Southeast Asia extra ---
    "Port of Ho Chi Minh (Hiep Phuoc) Customs (Vietnam)",
    "Hanoi Noi Bai Airport Customs (Vietnam)",
    "Port of Bangkok (Khlong Toei) Customs (Thailand)",
    "Port of Sihanoukville Customs (Cambodia)",
    "Phnom Penh Airport Customs (Cambodia)",
    "Port of Yangon Customs (Myanmar)",
    "Yangon Airport Customs (Myanmar)",
    "Port of Brunei Muara Customs (Brunei)",
    "Port of Singapore (PSA/Tuas) Customs (Singapore)",

    // --- WORLD: Africa extra ---
    "Port of Djibouti Customs (Djibouti)",
    "Port of Abidjan Customs (Côte d’Ivoire)",
    "Port of Tema Customs (Ghana)",
    "Port of Lome Customs (Togo)",
    "Port of Cotonou Customs (Benin)",
    "Port of Dakar Customs (Senegal)",
    "Port of Casablanca Customs (Morocco)",
    "Port of Algiers Customs (Algeria)",
    "Port of Tunis (Rades) Customs (Tunisia)",
    "Port of Tripoli Customs (Libya)",
    "Cairo Airport Customs (Egypt)",
    "Port of Dar es Salaam Customs (Tanzania)",
    "Port of Beira Customs (Mozambique)",
    "Port of Maputo Customs (Mozambique)",
    "Port of Luanda Customs (Angola)",

    // --- WORLD: Americas extra ---
    "Port of Halifax Customs (Canada)",
    "Calgary Airport Customs (Canada)",
    "Vancouver Airport (YVR) Customs (Canada)",
    "Port of Seattle-Tacoma Customs (USA)",
    "Port of Oakland Customs (USA)",
    "Port of Charleston Customs (USA)",
    "Port of Miami Customs (USA)",
    "Port of Baltimore Customs (USA)",
    "Dallas/Fort Worth Airport Customs (USA)",
    "Atlanta Airport Customs (USA)",
    "Newark Airport Customs (USA)",
    "JFK Airport Customs (USA)",
    "Port of Veracruz Customs (Mexico)",
    "Mexico City Airport Customs (Mexico)",
    "Port of Colon Customs (Panama)",
    "Port of Balboa Customs (Panama)",
    "Port of Cartagena Customs (Colombia)",
    "Bogotá Airport Customs (Colombia)",
    "Port of Guayaquil Customs (Ecuador)",
    "Port of Valparaiso Customs (Chile)",
    "Santiago Airport Customs (Chile)",
    "Port of Montevideo Customs (Uruguay)",

    // --- WORLD: Oceania extra ---
    "Brisbane Port Customs (Australia)",
    "Port of Fremantle Customs (Australia)",
    "Sydney Airport Customs (Australia)",
    "Melbourne Airport Customs (Australia)",
    "Port of Tauranga Customs (New Zealand)",
    "Auckland Airport Customs (New Zealand)",
];